export default __webpack_public_path__ + "static/media/156.497217c4.png";